import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfSocial {
  static async gerarRelatorio(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
    socialMapImage,
    rendaExclusivaImage,
    creditoRuralImage,
    possuiEmpresaImage,
    rendaPrincipalImage,
    dificuldadeImage,
    empreendedorismoImage,
    recebeRecursosImage,
    atividadeRuralImage,
  ) {
    const [
      propriedades,
      areaMedia,
      rendaExclusivaData,
      creditoRuralData,
      possuiEmpresaData,
      rendaPrincipalData,
      dificuldadeData,
      empreendedorismoData,
      recebeRecursosData,
      atividadeRuralData,
    ] = await Promise.all([
      Api.getNumeroPropriedadesSocial(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getAreaMediaSocial(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getRendaExclusiva(
        distrito,
        null,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getCreditoRural(
        distrito,
        rendaExclusiva,
        null,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getPossuiEmpresa(
        distrito,
        rendaExclusiva,
        creditoRural,
        null,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getRendaPrincipalRural(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        null,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getMaiorDificuldade(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        null,
        empreendedorismo,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getEmpreendedorismo(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        null,
        recebeRecursos,
        atividadeRural,
      ),
      Api.getRecebeRecursos(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        null,
        atividadeRural,
      ),
      Api.getAtividadePrincipal(
        distrito,
        rendaExclusiva,
        creditoRural,
        possuiEmpresa,
        rendaPrincipal,
        dificuldade,
        empreendedorismo,
        recebeRecursos,
        null,
      ),
    ]);

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades.value,
      areaMedia.value,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      socialMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(
      doc,
      propriedades.value,
      rendaExclusivaData.value,
      creditoRuralData.value,
      possuiEmpresaData.value,
      rendaExclusivaImage,
      creditoRuralImage,
      possuiEmpresaImage,
      imgSize,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageThree(
      doc,
      propriedades.value,
      rendaPrincipalData.value,
      dificuldadeData.value,
      empreendedorismoData.value,
      rendaPrincipalImage,
      dificuldadeImage,
      empreendedorismoImage,
      imgSize,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageFour(
      doc,
      propriedades.value,
      recebeRecursosData.value,
      atividadeRuralData.value,
      recebeRecursosImage,
      atividadeRuralImage,
      imgSize,
    );

    const fileName =
      "Relatorio_Social_" + distrito + "_" + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static pageOne(
    doc,
    distrito,
    propriedades,
    areaMedia,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
    socialMapImage,
  ) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Renda exclusiva:", rendaExclusiva || "Não informado"],
      ["Credito rural:", creditoRural || "Não informado"],
      ["Possui empresa:", possuiEmpresa || "Não informado"],
      ["Renda principal:", rendaPrincipal || "Não informado"],
      ["Maior dificuldade:", dificuldade || "Não informado"],
      ["Empreendedorismo:", empreendedorismo || "Não informado"],
      ["Recebe recursos:", recebeRecursos || "Não informado"],
      ["Atividade Rural:", atividadeRural || "Não informado"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades:   ", propriedades],
      ["Área média:   ", areaMedia.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(socialMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(
    doc,
    propriedades,
    rendaExclusivaData,
    creditoRuralData,
    possuiEmpresaData,
    rendaExclusivaImage,
    creditoRuralImage,
    possuiEmpresaImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      rendaExclusivaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Verifica-se que ${this.calcPercentual(rendaExclusivaData["01 - Não"], propriedades)}% dos entrevistados declararam que sua renda não vem exclusivamente de atividades rurais, enquanto ${this.calcPercentual(rendaExclusivaData["02 - Sim"], propriedades)}% informaram ter renda exclusiva proveniente da atividade rural.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    doc.addImage(
      creditoRuralImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Observa-se que ${this.calcPercentual(creditoRuralData["02 - Sim"], propriedades)}% dos participantes afirmaram possuir crédito rural, enquanto ${this.calcPercentual(creditoRuralData["01 - Não"], propriedades)}% disseram não ter acesso a esse tipo de financiamento.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    doc.addImage(
      possuiEmpresaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Constata-se que ${this.calcPercentual(possuiEmpresaData["02 - Sim"], propriedades)}% dos respondentes informaram ser proprietário de empresa, ao passo que ${this.calcPercentual(possuiEmpresaData["01 - Não"], propriedades)}% declararam não possuir nenhum empreendimento formalizado.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageThree(
    doc,
    propriedades,
    rendaPrincipalData,
    dificuldadeData,
    empreendedorismoData,
    rendaPrincipalImage,
    dificuldadeImage,
    empreendedorismoImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      rendaPrincipalImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Verifica-se que ${this.calcPercentual(rendaPrincipalData["01 - Não"], propriedades)}% dos entrevistados relataram não ter a renda principal vinculada à atividade rural, enquanto ${this.calcPercentual(rendaPrincipalData["02 - Sim"], propriedades)}% declararam ter a atividade rural como renda principal. `,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      dificuldadeImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Identifica-se que ${this.calcPercentual(dificuldadeData["02 - Escoamento da Produção"], propriedades)}% dos respondentes apontaram escoamento da produção como principal dificuldade, ${this.calcPercentual(dificuldadeData["01 - Aquisição de Insumos"], propriedades)}% indicaram aquisição de insumos, ${this.calcPercentual(dificuldadeData["03 - Condições Ambientais"], propriedades)}% mencionaram condições ambientais e ${this.calcPercentual(dificuldadeData["04 - Outros"], propriedades)}% classificaram como outras dificuldades.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      empreendedorismoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Nota-se que ${this.calcPercentual(empreendedorismoData["01 - Não"], propriedades)}% dos entrevistados indicaram não ter interesse em empreender, enquanto ${this.calcPercentual(empreendedorismoData["02 - Sim"], propriedades)}% afirmaram ter interesse.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageFour(
      doc,
      propriedades,
      recebeRecursosData,
      atividadeRuralData,
      recebeRecursosImage,
      atividadeRuralImage,
      imgSize,
  ) {
    let y = 40;

    doc.addImage(
      recebeRecursosImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Apura-se que ${this.calcPercentual(recebeRecursosData["02 - Sim"], propriedades)}% dos participantes informaram receber algum tipo de recurso, enquanto ${this.calcPercentual(recebeRecursosData["01 - Não"], propriedades)}% afirmaram não receber apoio financeiro. `,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      atividadeRuralImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Observa-se que ${this.calcPercentual(atividadeRuralData["01 - Não"], propriedades)}% dos entrevistados declararam não ter a atividade rural como principal fonte de renda, enquanto ${this.calcPercentual(atividadeRuralData["02 - Sim"], propriedades)}% informaram ter atividade rural como principal fonte de trabalho.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório dos aspectos socioeconômicos  ",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "propriedades rurais cadastradas",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );
    doc.text(
      "no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      27,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfSocial;
